import { IUniqueIssue, PRODUCT_NAME } from 'src/apps/dashboard/pages/issues/types/IssuesTypes';

import { GetUniqueIssuesQuery } from '../UniqueIssues.generated';

export interface IUniqueIssuesResult {
	issues: IUniqueIssue[];
	totalCount: number;
	unfilteredTotal: number;
}

const productNameMap: Record<string, PRODUCT_NAME> = {
	WEB_FLOW_ANALYZER: PRODUCT_NAME.WEB_FLOW_ANALYZER,
	WEB_SDK: PRODUCT_NAME.WEB_SDK
};

const getProductName = (productName: string): PRODUCT_NAME => {
	return productNameMap[productName] ?? PRODUCT_NAME.WEB_SDK;
};

export const transformUniqueIssuesResults = (result: GetUniqueIssuesQuery): IUniqueIssuesResult => {
	const issues = result?.uniqueness_issues || [];
	const totalArray = result?.total || [];
	const unfilteredTotalArray = result?.unfilteredTotal || [];

	const transformedIssues: IUniqueIssue[] = issues
		.filter((issue): issue is NonNullable<typeof issue> => issue !== null)
		.map((issue) => ({
			id: issue.uniqueness_id,
			issueId: issue.last_issue_id,
			runId: issue.run_id,
			productName: getProductName(issue.product_name),
			issueType: issue.issue_type,
			severity: issue.severity,
			pageTitle: issue.page_title,
			pageUrl: issue.page_url,
			firstSeen: issue.first_seen,
			lastSeen: issue.last_seen
		}));

	const totalCount = totalArray[0]?.uniqueness_id_count || 0;
	const unfilteredTotal = unfilteredTotalArray[0]?.uniqueness_id_count || 0;

	return {
		issues: transformedIssues,
		totalCount,
		unfilteredTotal
	};
};
